var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24.0525,
    height: 24,
    rx: 12,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_600_2542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7031 12.0306C16.3337 12.0306 16.035 12.3293 16.035 12.6973V18.0306C16.035 18.3979 15.7357 18.6973 15.367 18.6973H6.01317C5.64432 18.6973 5.34508 18.3979 5.34508 18.0306V8.69727C5.34508 8.32996 5.64432 8.03064 6.01317 8.03064H11.3582C11.7277 8.03064 12.0263 7.73193 12.0263 7.36401C12.0263 6.99597 11.7277 6.69727 11.3582 6.69727H6.01317C4.90809 6.69727 4.00879 7.5946 4.00879 8.69727V18.0306C4.00879 19.1333 4.90809 20.0306 6.01317 20.0306H15.367C16.472 20.0306 17.3713 19.1333 17.3713 18.0306V12.6973C17.3713 12.3286 17.0726 12.0306 16.7031 12.0306Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.273 11.4236C10.2263 11.4702 10.1948 11.5295 10.1815 11.5935L9.70914 13.9509C9.68712 14.0602 9.72186 14.1729 9.80065 14.2522C9.86414 14.3156 9.94965 14.3495 10.0372 14.3495C10.0585 14.3495 10.0807 14.3475 10.1027 14.3429L12.4645 13.8716C12.53 13.8582 12.5895 13.8269 12.6356 13.7802L17.9218 8.50549L15.5599 6.14893L10.273 11.4236Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5545 4.51877C18.9032 3.86874 17.8435 3.86874 17.1927 4.51877L16.2681 5.44138L18.6299 7.79807L19.5545 6.87534C19.8699 6.56137 20.0436 6.14267 20.0436 5.69736C20.0436 5.25204 19.8699 4.83334 19.5545 4.51877Z",
    fill: "#454545"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_600_2542"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.035,
    height: 16,
    fill: "white",
    transform: "translate(4.00879 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.fd12c9683127a3be237d3b1dac102ff2.svg";
export { ForwardRef as ReactComponent };